<template>
  <div>
    <div class="content-header">
      <div>
        <h2 class="content-title card-title">Update Division</h2>
      </div>
    </div>

    <a-card v-if="division">
      <a-form :form="form" @submit="handleSubmit">
        <a-form-item label="Name (EN)">
          <a-input
            size="large"
            v-decorator="[
              'name_en',
              {
                rules: [{ required: true, message: 'Please enter name' }],
                initialValue: division.name_en,
              },
            ]"
            placeholder="Enter name"
          />
        </a-form-item>

        <a-form-item label="Name (BN)">
          <a-input
            size="large"
            v-decorator="[
              'name_bn',
              {
                rules: [{ required: true, message: 'Please enter name' }],
                initialValue: division.name_bn,
              },
            ]"
            placeholder="Enter name"
          />
        </a-form-item>
        <a-form-item label="Status">
          <a-select
            size="large"
            v-decorator="[
              'status',
              {
                rules: [{ required: true, message: 'Please select Status!' }],
                initialValue: division.status,
              },
            ]"
            placeholder="Select Status"
          >
            <a-select-option :value="1"> Active </a-select-option>
            <a-select-option :value="0"> Inactive </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            class="btn btn-xs"
            size="large"
            html-type="submit"
          >
            Update Division
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
    <a-card v-else>
      <h4>Division not find</h4>
    </a-card>
  </div>
</template>

<script>
import { DIVISION_LIST, DIVISION_UPDATE } from "../../../script/api";
import { getData, postData } from "../../../script/api-service";
import { alertPop } from "../../../script/helper";

export default {
  props: ["divisionId"],
  data() {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      division: null,
    };
  },
  methods: {
    async getDivision() {
      let res = await getData(DIVISION_LIST);

      if (res) {
        let masterData = res.data?.data;
        this.division = masterData.find((e) => e.id == this.divisionId);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          let data = {};

          if (this.division.name_bn !== values.name_bn)
            data.name_bn = values.name_bn;
          if (this.division.name_en !== values.name_en)
            data.name_en = values.name_en;
          if (this.division.status !== values.status)
            data.status = values.status;

          if (Object.keys(data).length) {
            data.division_id = this.divisionId;

            let res = await postData(DIVISION_UPDATE, data);

            if (res) {
              alertPop("success", "Division updated successfully!");

              this.$router.push({ path: "/manage-division" });
            }
          } else {
            alertPop("warning", "No change found");
          }
        }
      });
    },
  },
  mounted() {
    this.getDivision();
  },
};
</script>